import {t} from "i18next";
import {Modal} from "../components/Modal";
import React from "react";
import {toast} from "react-toastify";

export const MembershipCardModal = (props) => {
	const {
		showMembershipCardModal,
		setShowMembershipCardModal,
		accountDetails
	} = props;

	return (
		<Modal isOpen={showMembershipCardModal}>
			<div
				className="form-modal-container !rounded-lg
                    portrait:!min-h-fit portrait:!h-fit portrait:!max-h-fit
                    portrait:min-w-[20rem] portrait:w-[20rem] portrait:max-w-[20rem]
                    landscape:min-w-[35rem] landscape:w-[35rem] landscape:max-w-[35rem]"
			>
				{/* Header */}
				<div className="form-modal-header-container">
					{/* Header Title | Close Button */}
					<div className={"flex flex-row items-center justify-between"}>
						{/* Form Title */}
						<h2>
							{t("MEMBERSHIP_CARD_MODAL.TITLE")}
						</h2>

						{/* Close Button */}
						<button
							onClick={() => {
								setShowMembershipCardModal(false);
							}}
						>
							<img
								className={"w-[75%] aspect-square"}
								src={"/assets/close-icon.png"}
								alt={"Close"}
								title={"Close"}
							/>
						</button>
					</div>

					{/* Divider */}
					<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
				</div>

				{/* Body - Membership Card */}
				<div className="form-modal-body-container">
					{/* Membership Card */}
					<div
						className="relative flex flex-col items-center justify-center
                            portrait:h-[10rem] landscape:h-[18rem]"
					>
						{/* Background Image */}
						<img
							className={`absolute aspect-auto object-cover h-full w-full rounded-lg`}
							src={"/assets/membership-card-background.png"}
							alt={"Membership Card"}
							title={"Membership Card"}
						/>

						{/* Details */}
						<div
							className={`z-10 flex flex-col justify-between h-full w-full
                                portrait:p-[1rem] landscape:p-[1.5rem]`}
						>
							{/* Header */}
							<div className={"z-10 flex items-center justify-between h-[30%] w-full"}>
								{/* JoglekarKul Logo */}
								<div className={"h-full aspect-square"}>
									<img
										className={"h-full aspect-square"}
										src={"/assets/joglekarkul-logo-gradient.svg"}
										alt={"JoglekarKul"}
										title={"JoglekarKul"}
									/>
								</div>

								{/* Title */}
								<div className={"h-full aspect-auto flex items-center justify-center"}>
									<img
										className={"portrait:h-[65%] landscape:h-[45%] aspect-auto"}
										src={"/assets/membership-card-title.svg"}
										alt={"JoglekarKul"}
										title={"JoglekarKul"}
									/>
								</div>
							</div>

							{/* Body - Details */}
							<div className={"z-10 flex items-center justify-between h-[45%] w-full"}>
								{/* Member Name | Membership Number */}
								<div className={"h-full flex-1 flex flex-col justify-between gap-x-[1rem]"}>
									{/* Member Name */}
									<div className={"flex flex-col gap-y-[0.1rem]"}>
										<p
											className={`font-custom-regular leading-tight text-white
                                                portrait:text-[0.375rem] landscape:text-[0.65rem]`}
										>
											Member Name
										</p>
										<p
											className={`font-custom-semi-bold leading-tight text-white
                                                portrait:text-[0.75rem] landscape:text-[1.65rem]`}
										>
											{`${accountDetails.firstName} ${accountDetails.middleName}`}
										</p>
									</div>

									{/* Membership ID */}
									<div className={"flex flex-col gap-y-[0.1rem]"}>
										<p
											className={`font-custom-regular leading-tight text-white
                                                portrait:text-[0.375rem] landscape:text-[0.65rem]`}
										>
											Membership ID
										</p>
										<p
											className={`font-custom-semi-bold leading-tight text-white
                                                portrait:text-[0.75rem] landscape:text-[1.65rem]`}
										>
											{`${accountDetails.membershipType}-${accountDetails.membershipNumber}`}
										</p>
									</div>
								</div>

								{/* Profile Picture | QR Code */}
								<div className={"h-full flex gap-x-[1rem]"}>
									<div
										className={`h-full aspect-square flex items-center justify-center 
                                            ${accountDetails.imageUrlBg} border-2 border-white`}
									>
										{
											accountDetails.imageUrl &&
											accountDetails.imageUrl.length <= 2
												? (
													<p
														className="text-white font-custom-mono-bold
                                                        portrait:text-[2rem] landscape:text-[1.75rem]"
													>
														{accountDetails.imageUrl.toUpperCase()}
													</p>

												) : (
													<img
														className="object-cover h-full w-full"
														src={accountDetails.imageUrl}
														alt="User Profile Image"
														referrerPolicy={"no-referrer"}
													/>
												)
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Footer */}
				<div className="form-modal-footer-container">
					{/* Divider */}
					<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

					{/* Submit Button Container */}
					<div className="flex justify-between">
						{/* Download Button */}
						<button
							// disabled={isSaveButtonDisabled}
							// onClick={handleSubmit}
							onClick={() => {
								toast.dismiss();
								toast.info("Coming Soon!");
							}}
							className="form-modal-footer-container-submit-button"
						>
							<p>
								{t("MEMBERSHIP_CARD_MODAL.DOWNLOAD")}
							</p>
							<svg
								viewBox="0 0 6 6"
								fill="none"
								id={"arrow-icon"}
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M3 1L5 3L3 5"
									id={"arrow-icon-tip"}
									stroke="black"
									strokeLinecap="square"
								/>
								<path
									d="M1 3L4 3"
									id={"arrow-icon-line"}
									stroke="black"
									strokeLinecap="square"
								/>
							</svg>
						</button>

						{/* Submit Button */}
						<button
							// disabled={isSaveButtonDisabled}
							// onClick={handleSubmit}
							onClick={() => {
								toast.dismiss();
								toast.info("Coming Soon!");
							}}
							className="form-modal-footer-container-submit-button"
						>
							<p>
								{t("MEMBERSHIP_CARD_MODAL.PRINT")}
							</p>
							<svg
								viewBox="0 0 6 6"
								fill="none"
								id={"arrow-icon"}
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M3 1L5 3L3 5"
									id={"arrow-icon-tip"}
									stroke="black"
									strokeLinecap="square"
								/>
								<path
									d="M1 3L4 3"
									id={"arrow-icon-line"}
									stroke="black"
									strokeLinecap="square"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
		</Modal>
	)
}
